// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyA47t2BGK41_odHwS9TQX8g9AiIfUkVuig',
  authDomain: 'daniel-arnold-website-2963a.firebaseapp.com',
  projectId: 'daniel-arnold-website-2963a',
  storageBucket: 'daniel-arnold-website-2963a.appspot.com',
  messagingSenderId: '965191059250',
  appId: '1:965191059250:web:626574a66024d8d48bf92b',
  measurementId: 'G-V7R9VC77E1',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
